/* eslint-disable @typescript-eslint/no-explicit-any */
const highlightValue = <T,>(value: T, searchValue: string) => {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: String(value).replace(
          new RegExp(`(${searchValue})`, 'i'),
          '<span class="text-vividTangelo">$1</span>'
        ),
      }}
    ></span>
  );
};

export const highlightFoundText = (
  o: Record<string, any>,
  searchValue: string
) => {
  const object = { ...o };
  const hasValue = <T,>(val: T) =>
    String(val).toLowerCase().includes(searchValue.toLowerCase());

  Object.entries(object).forEach(([k1, v1]) => {
    if (v1 instanceof Object && v1 !== null) {
      Object.entries(v1).forEach(([k2, v2]) => {
        if (hasValue(v2)) {
          object[k1] = {
            ...object[k1],
            [k2]: highlightValue(v2, searchValue),
          };
        }
      });

      return;
    }

    if (hasValue(v1)) {
      object[k1] = highlightValue(v1, searchValue);
    }
  });

  return object;
};
